export function staticImplements() {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return (constructor) => { };
}
